export enum SteamType {
  Steam900 = '#900',
  Steam600 = '#600',
  Steam150 = '#150',
  Steam50 = '#50',
}
